var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_63635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67197 0H53.4095V45H8.6626L8.67197 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2812 0.337402H63.8438V21.1218H30.2812V0.337402Z",
    fill: "#DB0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.299805 21.1218H30.2904V44.9999H0.299805V21.1218ZM20.1373 16.6593L16.1998 13.903L12.2904 16.678L13.7436 12.178L9.84356 9.3749L14.6811 9.3374L16.1811 4.8374L17.7092 9.32803H22.5467L18.6561 12.1405L20.1467 16.6405L20.1373 16.6593Z",
    fill: "#0000AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4594 38.8029L44.4844 36.2061L40.5375 38.8311L42 34.5561L38.0625 31.9311L42.9375 31.8842L44.4563 27.6279L45.9938 31.8748H50.8687L46.95 34.5467L48.45 38.8029H48.4594Z",
    fill: "#D80000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_63635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanFlag);
export default __webpack_public_path__ + "static/media/pan-flag.4b320f58181316cf4ec10973f156ce7d.svg";
export { ForwardRef as ReactComponent };